import { createRouter, createWebHashHistory, RouteRecordRaw, createWebHistory } from 'vue-router';
import { usePermissStore } from '../store/permiss';
import Home from '../views/home.vue';
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

const routes: RouteRecordRaw[] = [
    {
        path: '/',
        redirect: '/fileKnow',
    },
    {
        path: '/video',
        name: 'VideoDetail',
        component: () => import('../views/detail/VideoDetail.vue')
      }, 
    {
        path: '/',
        name: 'Home',
        component: Home,
        children: [
            // {
            //     path: '/dashboard',
            //     name: 'dashboard',
            //     meta: {
            //         title: '系统首页',
            //         permiss: '1',
            //     },
            //     component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard.vue'),
            // },
            {
                path: '/fileKnow',
                name: 'fileKnow',
                meta: {
                    title: '文档',
                    permiss: '1',
                },
                component: () => import(/* webpackChunkName: "dashboard" */ '../views/fileKnow.vue'),
            },
              
                   
              {
                path: '/more',
                name: 'More',
                component: () => import('../views/More.vue')
              },                          
            {
                path: '/copyright',
                name: 'copyright',
                meta: {
                    title: '文档',
                    permiss: '1',
                },
                component: () => import(/* webpackChunkName: "dashboard" */ '../views/copyright.vue'),
            },
           
            {
                path: '/privacy',
                name: 'privacy',
                meta: {
                    title: '文档',
                    permiss: '1',
                },
                component: () => import(/* webpackChunkName: "dashboard" */ '../views/privacy.vue'),
            },
            {
                path: '/privacy',
                name: 'privacy',
                meta: {
                    title: '文档',
                    permiss: '1',
                },
                component: () => import(/* webpackChunkName: "dashboard" */ '../views/privacy.vue'),
            },
            {
                path: '/termsofuse',
                name: 'termsofuse',
                meta: {
                    title: '文档',
                    permiss: '1',
                },
                component: () => import(/* webpackChunkName: "dashboard" */ '../views/aboutus.vue'),
            },
            {
                path: '/contactus',
                name: 'contactus',
                meta: {
                    title: '文档',
                    permiss: '1',
                },
                component: () => import(/* webpackChunkName: "dashboard" */ '../views/contactus.vue'),
            },
            {
                path: '/disclaimer',
                name: 'disclaimer',
                meta: {
                    title: '文档',
                    permiss: '1',
                },
                component: () => import(/* webpackChunkName: "dashboard" */ '../views/disclaimer.vue'),
            },
            // {
            //     path: '/tos',
            //     name: 'tos',
            //     meta: {
            //         title: '文档',
            //         permiss: '1',
            //     },
            //     component: () => import(/* webpackChunkName: "dashboard" */ '../views/tos.vue'),
            // },
            {
                path: '/permission',
                name: 'permission',
                meta: {
                    title: '权限管理',
                    permiss: '13',
                },
                component: () => import(/* webpackChunkName: "permission" */ '../views/permission.vue'),
            },
            
            // {
            //     path: '/user',
            //     name: 'user',
            //     meta: {
            //         title: '个人中心',
            //     },
            //     component: () => import(/* webpackChunkName: "user" */ '../views/user.vue'),
            // },
            // {
            //     path: '/editor',
            //     name: 'editor',
            //     meta: {
            //         title: '富文本编辑器',
            //         permiss: '8',
            //     },
            //     component: () => import(/* webpackChunkName: "editor" */ '../views/editor.vue'),
            // },
            
        ],
    },
    
    {
        path: '/403',
        name: '403',
        meta: {
            title: '没有权限',
        },
        component: () => import(/* webpackChunkName: "403" */ '../views/403.vue'),
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        // 始终滚动到顶部
        return { top: 0 }
    }
});

router.beforeEach((to, from, next) => {
    NProgress.start();
    const role = localStorage.getItem('ms_username');
    const permiss = usePermissStore();
    // if (!role && to.path !== '/login') {
    //     next('/login');
    // } else if (to.meta.permiss && !permiss.key.includes(to.meta.permiss)) {
    //     // 如果没有权限，则进入403
    //     next('/403');
    // } else {
        next();
    // }
});

router.afterEach(() => {
    NProgress.done()
})

export default router;
